// extracted by mini-css-extract-plugin
module.exports = {"waterfullBody":"waterfullBody--1BDm5","imgItem":"imgItem--911ap"};